export class UserGroupNameAlreadyExists extends Error {
  constructor() {
    super('A user group with this name already exists in this court system.')
    Object.setPrototypeOf(this, UserGroupNameAlreadyExists.prototype)
  }
}
